var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlistLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79378 0C2.14666 0 0 2.1246 0 4.74584C0 6.86182 0.838912 11.8838 9.09668 16.9604C9.2446 17.0504 9.41441 17.098 9.58756 17.098C9.76071 17.098 9.93053 17.0504 10.0784 16.9604C18.3362 11.8838 19.1751 6.86182 19.1751 4.74584C19.1751 2.1246 17.0285 0 14.3813 0C11.7342 0 9.58756 2.87627 9.58756 2.87627C9.58756 2.87627 7.44091 0 4.79378 0Z",
    fill: "#FB1313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistLike);
export default __webpack_public_path__ + "static/media/wishlist_like.ce0a374df32e8e7f55aa5eb872eb36f2.svg";
export { ForwardRef as ReactComponent };